import {InfoOutlineIcon} from "@chakra-ui/icons";
import {Box, Tooltip, TooltipProps} from "@chakra-ui/react";
import {ReactNode} from "react";
import {HELP_TOOLTIP_DELAY_MS} from "./helpConfig";

type Props = {
	content: ReactNode,
	children?: ReactNode,
	openDelayMs?: number,
	placement?: TooltipProps["placement"],
	icon?: boolean,
	iconAriaLabel?: string
}

const HelpTooltip = ({
	content,
	children,
	openDelayMs = HELP_TOOLTIP_DELAY_MS,
	placement = "top",
	icon = false,
	iconAriaLabel = "More info"
}: Props) => {
	const iconNode = (
		<Box
			as={"span"}
			paddingLeft={"4px"}
			display={"inline-flex"}
			alignItems={"center"}
			onClick={(event) => event.stopPropagation()}
			onMouseDown={(event) => event.stopPropagation()}
			onKeyDown={(event) => event.stopPropagation()}
			tabIndex={0}
			role={"img"}
			aria-label={iconAriaLabel}
		>
			<InfoOutlineIcon color={"gray.500"}/>
		</Box>
	);

	return (
		<Tooltip label={<Box maxWidth={"320px"} whiteSpace={"normal"}>{content}</Box>}
		         openDelay={openDelayMs}
		         closeDelay={80}
		         hasArrow
		         placement={placement}
		         bg={"gray.700"}
		         color={"white"}
		         padding={3}
		         borderRadius={"md"}
		         boxShadow={"lg"}>
			<Box as={"span"} display={"inline-flex"} alignItems={"center"} columnGap={"6px"}>
				{children}
				{icon ? iconNode : null}
			</Box>
		</Tooltip>
	);
}

export default HelpTooltip;
